import axios from './api'
const attestationServer = {	
	AddAttestation(params) {
		return axios.post(`user/auth/submit`, params).then((res) => {
            return res.data
        })
	},
	Upload(params) {
		return axios.post(`admin/file/upload`, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			return res.data
		})
	},
	SearchAStatus(params) {
		return axios.post(`user/auth/getStatus`, params).then((res) => {
            return res.data
        })
	}

}

export default attestationServer


// WEBPACK FOOTER //
// ./src/api/attestation.js